<template>
  <v-card>
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Mercadería en Consignación</div>
    </v-card>
    <v-card-text>
      <v-card>
        <v-toolbar>
          <v-autocomplete
            label="Campaña"
            :items="campaignItems"
            :loading="isLoadingCampaign"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            return-object
            v-model="selectedCampaign"
            @change="campaignSelected($event)"
            @click:prepend="clearAutocomplete('campaignAutocomplete')"
            ref="campaignAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Cultivo"
            :items="cropItems"
            :loading="isLoadingCrops"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            return-object
            v-model="selectedCrop"
            @change="cropSelected($event)"
            @click:prepend="clearAutocomplete('cropAutocomplete')"
            ref="cropAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-text-field
            disabled
            hide-details
            v-model="selectedClientName"
            label="Cliente"
          >
            <v-icon
              slot="append-outer"
              class="enabled-icon"
              @click="clientSearchClick"
            >
              mdi-magnify
            </v-icon>
            <!-- eslint-disable -->
            <v-icon
              slot="prepend"
              :class="filterClient
                  ? 'enabled-icon'
                  : 'disabled-icon'
              "
              @click="clientSelected(null)"
            >
              mdi-close
            </v-icon>
          </v-text-field>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Producto"
            :items="productItems"
            :search-input.sync="searchProduct"
            :loading="isLoadingProducts"
            hide-details
            hide-no-data
            hide-selected
            :item-text="getProductText"
            item-value="url"
            v-model="selectedProduct"
            return-object
            @change="productSelected($event)"
            ref="productAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('productAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Banda"
            :items="bandItems"
            :loading="isLoadingBands"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedBand"
            return-object
            @change="bandSelected($event)"
            ref="bandAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('bandAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Calibre"
            :items="gaugeItems"
            :loading="isLoadingGauges"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedGauge"
            return-object
            @change="gaugeSelected($event)"
            ref="gaugeAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('gaugeAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Curado"
            :items="curingItems"
            :loading="isLoadingCuring"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedCuring"
            return-object
            @change="curingSelected($event)"
            ref="curingAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('curingAutocomplete')"
          ></v-autocomplete>
        </v-toolbar>
      </v-card>
    </v-card-text>
    <v-card-text>
      <v-card>
        <v-data-table
          dense
          :loading="isLoading"
          :headers="headers"
          :items="items"
          :itemsPerPage="itemsPerPage"
          :serverItemsLength="serverItemsLength"
          :options.sync="options"
          :pageCount="this.pageCount"
          class="consignment-table"
        >
          <template v-slot:top="{ pagination, options, updateOptions }">
            <v-data-footer 
              :pagination="pagination" 
              :options="options"
              @update:options="updateOptions"
              items-per-page-text="$vuetify.dataTable.itemsPerPageText"/>
          </template>
        </v-data-table>      
      </v-card>    
    </v-card-text>
    <paginated-search-dialog
      v-if="consignmentShowSearch"
      :show="consignmentShowSearch"
      :title="consignmentSearchOptions.title"
      :endpoint="consignmentSearchOptions.endpoint"
      :ordering="consignmentSearchOptions.ordeting"
      :searchLabel="consignmentSearchOptions.searchLabel"
      :headers="consignmentSearchOptions.headers"
      :filterString="consignmentSearchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      :searchOnURL="consignmentSearchOptions.searchOnURL"
      @itemSelected="searchSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>
  </v-card>
</template>
<script>
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";

export default {
  name: "ConsignmentReport",

  components: {
    PaginatedSearchDialog
  },

  data() {
    return {
      mounting: true,
      isLoading: false,
      items: [],
      endpoint: "/data/inventories_search",
      page: 1,
      serverItemsLength: 0,
      pageCount: 0,
      itemsPerPage: 100,
      options: {},

      headers: [
        { text: "Cliente", value: "client_name", sorteable: false },
        { text: "Codigo", value: "product_code", sortable: false },
        { text: "Producto", value: "product_description", sortable: false },
        { text: "Banda", value: "band_description", sorteable: false },
        { text: "Calibre", value: "gauge_description", sortable: false },
        { text: "Curado", value: "curing_description", sortable: false },
        { text: "Tipo", value: "sector_description", sorteable: false },
        {
          text: "Inventario Total",
          value: "inventory_amount",
          sorteable: false,
          align: "end"
        },
        {
          text: "Reservado",
          value: "reserved_amount",
          sorteable: false,
          align: "end"
        },
        {
          text: "Inventario Disponible",
          value: "available_amount",
          sorteable: false,
          align: "end"
        }
      ],

      consignmentShowSearch: false,
      consignmentSearchOptions: {},
      selectedClientName: "",
      searchProduct: "",

      campaignItems: [],
      cropItems: [],
      productItems: [],
      bandItems: [],
      gaugeItems: [],
      curingItems: [],

      isLoadingCampaign: false,
      isLoadingCrops: false,
      isLoadingProducts: false,
      isLoadingBands: false,
      isLoadingGauges: false,
      isLoadingCuring: false,

      selectedCampaign: null,
      selectedCrop: null,
      selectedProduct: null,
      selectedBand: null,
      selectedGauge: null,
      selectedCuring: null,

      filterCampaign: null,
      filterCrop: null,
      filterClient: null,
      filterProduct: null,
      filterBand: null,
      filterGauge: null,
      filterCuring: null
    };
  },

  watch: {
    searchProduct: {
      handler(val) {
        this.loadProducts(val);
      }
    },
    options: {
      handler() {
        this.consignmentReadDataFromAPI(false);
      }
    },

    deep: true
  },

  methods: {
    async consignmentReadDataFromAPI(reset) {
      //Reading data from API method.
      try {
        if (!this.mounting) {
          this.isLoading = true;
          const { page, itemsPerPage } = this.options;
          let pageNumber = reset ? 1 : page;
          let endpoint =
            this.endpoint +
            "/0" +
            "/" +
            (this.filterCrop ? this.filterCrop.id.toString() : "0") +
            "/" +
            (this.filterProduct ? this.filterProduct.id.toString() : "0") +
            "/" +
            (this.filterGauge ? this.filterGauge.id.toString() : "0") +
            "/" +
            (this.filterCuring ? this.filterCuring.id.toString() : "0") +
            "/" +
            (this.filterBand ? this.filterBand.id.toString() : "0") +
            "/" +
            (this.filterClient ? this.filterClient.id.toString() : "-1") +
            "/-1" +
            "/0" + //order_id
            "/1"; //only_positives

          let res = await this.$bRoot.search(
            endpoint, null, null, null, pageNumber // eslint-disable-line
          );
          if (this.$bRoot.errors) {
            throw "Error recuperando datos";
          }
          if (res) {
            this.items = res.data.results.map(item => ({
              ...item,
              reserved_amount:
                (item.reserved_amount_softland || 0) +
                (item.reserved_amount_clon || 0)
            }));
            this.serverItemsLength = res.data.count;
            this.page = pageNumber;
            this.pageCount = Math.ceil(res.data.count / itemsPerPage);
          }
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.isLoading = this.mounting;
      }
    },

    async clientSearchClick() {
      try {
        if (!this.filterCampaign) {
          throw "Seleccione Campaña";
        }
        this.consignmentSearchOptions = {
          headers: [
            { text: "Código", value: "client_data.code", sortable: false },
            {
              text: "Identificación",
              value: "client_data.identification",
              sortable: false
            },
            { text: "Nombre", value: "client_data.name", sortable: false },
            {
              text: "Categoría",
              value: "client_data.category_object.description",
              sorteable: false
            }
          ],
          title: "Cliente...",
          endpoint:
            "/data/clients_hierarchy/" + this.filterCampaign.id.toString(),
          ordering: null,
          searchLabel: "Código/CUIT/Nombre",
          filterString: null,
          selected: "clientSelected",
          searchOnURL: true
        };
        this.consignmentShowSearch = true;
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
        this.consignmentShowSearch = false;
      }
    },

    async searchCanceled() {
      this.consignmentShowSearch = false;
      this.consignmentSearchOptions = {};
    },

    async searchSelected(data) {
      let selectedFunction = this.consignmentSearchOptions.selected;
      this.searchCanceled();
      this[selectedFunction](data.client_data);
    },

    async clientSelected(client) {
      if (client) {
        this.filterClient = client;
        this.selectedClientName = client.name;
      } else {
        this.filterClient = null;
        this.selectedClientName = "";
      }
      await this.consignmentReadDataFromAPI(true);
    },

    async loadProducts(searchString) {
      // Items have already been requested
      if (this.mounting) return;

      if (this.filterProduct) {
        if (this.getProductText(this.filterProduct) === searchString) return;
      }
      this.isLoadingProducts = true;
      try {
        this.filterProduct = null;
        this.productsItems = [];

        let filterString = this.filterCrop
          ? "crop__id=" + this.filterCrop.id.toString()
          : "";

        let products = await this.$bRoot.searchAll(
          "/data/products",
          searchString,
          "description",
          filterString
        );

        this.productItems = products;
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.isLoadingProducts = false;
      }
    },

    async loadBands() {
      this.isLoadingBands = true;
      this.filterBand = null;
      this.bandItems = [];

      let bands = await this.$bRoot.search(
        "/data/bands",
        null,
        "description",
        null
      );

      this.bandItems = bands.data.results;
      this.isLoadingBands = false;
    },

    async loadGauges() {
      this.isLoadingGauges = true;
      this.filterGauge = null;
      this.gaugeItems = [];

      // eslint-disable-next-line
      let filterString = this.filterCrop ? "crop__id=" + this.filterCrop.id.toString() : "";

      let gauges = await this.$bRoot.search(
        "/data/gauges",
        null,
        "description",
        filterString
      );

      this.gaugeItems = gauges.data.results;
      this.isLoadingGauges = false;
    },

    async clearAutocomplete(field) {
      //this.$refs[field].internalValue = [];
      switch (field) {
        case "productAutocomplete":
          this.filterProduct = null;
          this.selectedProduct = null;
          break;
        case "cropAutocomplete":
          this.filterCrop = null;
          this.selectedCrop = null;
          break;
        case "campaignAutocomplete":
          this.filterCampaign = null;
          this.selectedCampaign = null;
          break;
        case "bandAutocomplete":
          this.filterBand = null;
          this.selectedBand = null;
          break;
        case "curingAutocomplete":
          this.filterCuring = null;
          this.selectedCuring = null;
          break;
        case "gaugeAutocomplete":
          this.filterGauge = null;
          this.selectedGauge = null;
          break;
      }
      await this.consignmentReadDataFromAPI(true);
    },

    async productSelected(product) {
      if (product) {
        this.filterProduct = product;
      } else {
        this.filterProduct = null;
      }
      await this.consignmentReadDataFromAPI(true);
    },

    async cropSelected(crop) {
      if (crop) {
        this.filterCrop = crop;
        await this.loadProducts();
        await this.loadGauges();
      } else {
        this.filterCrop = null;
        this.selectedCrop = null;
      }
      await this.consignmentReadDataFromAPI(true);
    },

    async campaignSelected(campaign) {
      if (campaign) {
        this.filterCampaign = campaign;
      } else {
        this.filterCampaign = null;
        this.selectedCampaign = null;
      }
      await this.consignmentReadDataFromAPI(true);
    },

    async gaugeSelected(gauge) {
      if (gauge) {
        this.filterGauge = gauge;
      } else {
        this.filterGauge = null;
        this.gaugeSelected = null;
      }
      await this.consignmentReadDataFromAPI(true);
    },

    async bandSelected(band) {
      if (band) {
        this.filterBand = band;
      } else {
        this.filterBand = null;
        this.bandSelected = null;
      }
      await this.consignmentReadDataFromAPI(true);
    },

    async curingSelected(curing) {
      if (curing) {
        this.filterCuring = curing;
      } else {
        this.filterCuring = null;
        this.curingSelected = null;
      }
      await this.consignmentReadDataFromAPI(true);
    },

    getProductText(item) {
      return item.code + " - " + item.description;
    }
  },

  async mounted() {
    this.mounting = true;
    let index = 0;

    try {
      this.current_level = this.$bRoot.auth.current_level;

      //load campaigns
      // eslint-disable-next-line
      let campaigns = await this.$bRoot.search("/data/campaigns", null, "-code", "orders_enabled__in=S,D");
      this.campaignItems = campaigns.data.results;

      //set default
      let defaultCampaignId = this.$bRoot.getUserParam("defaultCampaignId");
      // eslint-disable-next-line
      index = this.campaignItems.findIndex(item => item.id == defaultCampaignId);
      if (index == -1) {
        index = this.campaignItems.findIndex(item => item.current === true);
      }
      if (index !== -1) {
        this.selectedCampaign = this.campaignItems[index].url;
        this.filterCampaign = this.campaignItems[index];
      }

      //load crops
      let crops = await this.$bRoot.search("/data/crops", null, "description");
      this.cropItems = crops.data.results;

      //set default
      let defaultCropId = this.$bRoot.getUserParam("defaultCropId");
      index = this.cropItems.findIndex(item => item.id === defaultCropId);
      if (index !== -1) {
        this.selectedCrop = this.cropItems[index].url;
        this.filterCrop = this.cropItems[index];
      }

      //load curings
      // eslint-disable-next-line
      let curings = await this.$bRoot.search("/data/curings", null, "description");
      this.curingItems = curings.data.results;

      //load gauges
      await this.loadGauges();

      //load bands
      await this.loadBands();
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.mounting = false;
      await this.consignmentReadDataFromAPI(true);
    }
  }
};
</script>
<style>
.enabled-icon {
  pointer-events: auto;
  color: black;
}
.consignment-table {
  margin-top: -20px !important;
}
.container {
  padding: 0px;
  height: 100%;
  max-height: 100%;
}
</style>
